import { render, staticRenderFns } from "./InicioDocente.vue?vue&type=template&id=497a02af&"
import script from "./InicioDocente.vue?vue&type=script&lang=js&"
export * from "./InicioDocente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports